// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SafetyControlSurveyReportApi {
	export async function generateReport(args: { safetyControlSurveyId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyReport/generateReport",
			method: "POST",
			data: {
				safetyControlSurveyId: args.safetyControlSurveyId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}
}
